import Actions from '../Collection/actions'

const actions = Actions.get('DISCOUNT_');

export default actions;
